import { render, staticRenderFns } from "./tiny-editor.vue?vue&type=template&id=b88f2b22&scoped=true&"
import script from "./tiny-editor.vue?vue&type=script&lang=js&"
export * from "./tiny-editor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./tiny-editor.vue?vue&type=style&index=1&id=b88f2b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88f2b22",
  null
  
)

export default component.exports